import React from 'react'
import { Header, Icon, Divider, Button } from 'semantic-ui-react'
import history from 'services/history'
import './Menu.scss'

export default function Menu({ path }) {
    return (
        <div id="template-mane-validfisco" className="row flex-grow-1 mt-2">
            <div className="col d-flex flex-column">
                <div className="row mx-0">
                    <div className="col">
                        <Header as='h3'>
                            <Icon.Group size='big'>
                                <Icon name='blind' className='primary-color' />
                            </Icon.Group>
                            <Header.Content className='primary-color'>
                                Valid Fisco <Header.Subheader className='secondary-color'>Menu</Header.Subheader>
                            </Header.Content>
                        </Header>
                    </div>
                </div>

                <Divider className='mt-2 custom-divider darken' fitted />

                <div className="row flex-grow-1 flex-column">
                    <div className="col d-flex align-items-center flex-column justify-content-center">
                        <Header textAlign='center' as='h2' color='orange' className='titleModulos'>
                            Módulos
                        </Header>
                        <Button fluid className='buttonInicioValidFisco' onClick={() => history.push(`${path}/combustiveis`)}>
                            <Icon name='tint' />
                            Combustíveis
                        </Button>
                        <Button disabled fluid className='buttonInicioValidFisco'>
                            <Icon name='file alternate outline' />
                            Em Breve
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}